import { render, staticRenderFns } from "./PSupportAttachment.vue?vue&type=template&id=51964461"
import script from "./PSupportAttachment.vue?vue&type=script&lang=js"
export * from "./PSupportAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports